import { render, staticRenderFns } from "./SouhaitsView.vue?vue&type=template&id=b9575a76&scoped=true&"
import script from "./SouhaitsView.vue?vue&type=script&lang=js&"
export * from "./SouhaitsView.vue?vue&type=script&lang=js&"
import style0 from "./SouhaitsView.vue?vue&type=style&index=0&id=b9575a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9575a76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
